<template lang="html">
    <div id="luws-menu">
        <md-tabs :md-active-tab="activeTab">
            <md-tab id="tab-luwprices" v-bind:to="{ name: 'LuwPrices'}" md-label="Список"></md-tab>
            <md-tab id="tab-settings" v-bind:to="{ name: 'LuwPricesSettings'}" md-label="Настройки"></md-tab>
        </md-tabs>
    </div>
</template>
<script>
    export default {
        name: 'luws-menu',
        data() {
            return {
                activeTab: null
            }
        },
        watch: {
            '$route'() {
                this.activeTab = 'tab-' + this.$route.meta.tab;
            }
        },
        created() {
            this.activeTab = 'tab-' + this.$route.meta.tab;
        }
    }
</script>



// WEBPACK FOOTER //
// LuwsMenu.vue?713f8745